import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import type { LiveQuoteReviewRow } from 'helpers/liveSlipSubmit';
import { ThemeIcon } from 'components/ThemeIcon/ThemeIcon';
import styles from './SlipCreationModalContent.module.css';
import { SlipCreationModalTypes } from 'types/enums';

interface Props {
  modalType: SlipCreationModalTypes;
  onConfirm?: (() => void) | undefined;
  onReject?: (() => void) | undefined;
  liveQuoteReviewRows?: LiveQuoteReviewRow[];
}

export const SlipCreationModalContent = ({
  modalType,
  onConfirm,
  onReject,
  liveQuoteReviewRows = [],
}: Props) => {
  const { t } = useTranslation();
  const suspended = modalType === SlipCreationModalTypes.QUOTE_SUSPENDED;

  if (modalType === SlipCreationModalTypes.LIVE_QUOTE_REVIEW) {
    return (
      <div className={classNames(styles.wrapper, styles.wrapperQuoteReview)}>
        <div className={styles.title}>{t('submit_bet_slip_mobile_title')}</div>
        <div className={styles.quoteReviewIntro}>
          {t('live_quote_review_intro')}
        </div>
        <table className={styles.quoteTable}>
          <thead>
            <tr>
              <th>{t('live_quote_selection_label')}</th>
              <th>{t('live_quote_before_label')}</th>
              <th>{t('live_quote_after_label')}</th>
            </tr>
          </thead>
          <tbody>
            {liveQuoteReviewRows.map((row) => (
              <tr key={row.key}>
                <td className={styles.quoteSelectionCell}>{row.label}</td>
                <td className={styles.quoteOddCell}>{row.before}</td>
                <td className={styles.quoteOddCell}>{row.after}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className={styles.buttonsWrapper}>
          <div onClick={onReject} role="button" tabIndex={0}>
            <ThemeIcon icon="arrow-left" alt="" variant="inline" />
          </div>
          <div onClick={onConfirm} role="button" tabIndex={0}>
            <ThemeIcon icon="check-lg" alt="" variant="inline" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>{t('submit_bet_slip_mobile_title')}</div>
      <div className={styles.message}>
        {t(
          suspended
            ? 'quote_suspended_message'
            : 'submit_bet_slip_mobile_message'
        )}
      </div>
      <div className={styles.buttonsWrapper}>
        <div onClick={onReject} role="button" tabIndex={0}>
          <ThemeIcon icon="arrow-left" alt="Close" variant="inline" />
        </div>
        <div onClick={onConfirm} role="button" tabIndex={0}>
          <ThemeIcon icon="check-lg" alt="Confirm" variant="inline" />
        </div>
      </div>
    </div>
  );
};
